<template>
	<ul :class="cssClass" >
		<menu-item v-for="(item, index) in menuList[listKey]" :key="index" :classValue="item.id in menuList ? 'nav-parent':''">
			<template v-if="item.id in menuList">
				<a
					href="javascript:;"
					class="nav-menu-link nav-menu-parent-link"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<i class="fa fa-fighter-jet" :style="{marginRight:'0.3rem'}"></i>
					<span
						class="nav-menu-title-wrap nav-menu-parent-title"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>
				<nav-menu :cssClass="'nav nav-children'" :listKey="item.id" :menuList="menuList"></nav-menu>
			</template>
			<template v-else>
				<a
					v-if="item.linkType == '2'"
					class="nav-content nav-menu-link"
					:href="item.linkValue"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<span
						class="nav-menu-title-wrap"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>
				<a
					v-else-if="item.linkType == '1'"
					class="nav-content nav-menu-link"
					:href="'javascript:;'"
					@click="gotoView(item.linkValue.name, item.linkValue.params)"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<span
						class="nav-menu-title-wrap"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>
				<a
					v-else-if="item.linkType == '90'"
					class="nav-content nav-menu-link"
					:href="'javascript:;'"
					@click="$parent.showStayStateControl(true)"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<span
						class="nav-menu-title-wrap"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>
				<a
					v-else-if="item.linkType == '91'"
					class="nav-content nav-menu-link"
					:href="'javascript:;'"
					@click="$parent.showStayBillingControl(true)"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<span
						class="nav-menu-title-wrap"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>
				<a
					v-else-if="item.linkType == '92'"
					class="nav-content nav-menu-link"
					:href="'javascript:;'"
					@click="$parent.showAssistStateControl(true, item.linkValue)"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<span
						class="nav-menu-title-wrap"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>
				<a
					v-else
					:href="'javascript:;'"
					class="nav-content nav-menu-link"
					@mouseenter="handleTitleHover($event, itemKey(item, index))"
					@focus="handleTitleHover($event, itemKey(item, index))"
				>
					<span
						class="nav-menu-title-wrap"
						:class="{ 'is-overflowing': isOverflowing(itemKey(item, index)) }"
						:style="getTitleStyle(itemKey(item, index))"
					>
						<span class="nav-menu-title-inner">{{item.title}}</span>
					</span>
				</a>

			</template>
		</menu-item>
	</ul>
</template>
<script>
import menuItem from './menuItem';
export default {
	name: "navMenu",
	props:["cssClass","listKey", "menuList"],
	components:{
		menuItem
	},
	mounted(){
	},
	data(){
		return{
			overflowState: {},
		}
	},
	methods: {
		itemKey(item, index) {
			return [this.listKey, item.id || 'leaf', item.linkType || '0', index].join('__');
		},
		handleTitleHover(event, key) {
			this.$nextTick(() => {
				this.updateOverflowState(event.currentTarget, key);
			});
		},
		updateOverflowState(anchor, key) {
			const titleWrap = anchor && anchor.querySelector('.nav-menu-title-wrap');
			const titleInner = anchor && anchor.querySelector('.nav-menu-title-inner');

			if (!titleWrap || !titleInner) {
				return;
			}

			const overflowDistance = Math.ceil(titleInner.scrollWidth - titleWrap.clientWidth);

			if (overflowDistance > 0) {
				const paddedDistance = overflowDistance + 16;
				const duration = Math.max(paddedDistance / 48, 2.2).toFixed(2);

				this.$set(this.overflowState, key, {
					isOverflowing: true,
					distance: paddedDistance,
					duration,
				});
				return;
			}

			this.$set(this.overflowState, key, {
				isOverflowing: false,
				distance: 0,
				duration: 0,
			});
		},
		isOverflowing(key) {
			return Boolean(this.overflowState[key] && this.overflowState[key].isOverflowing);
		},
		getTitleStyle(key) {
			const titleState = this.overflowState[key];

			if (!titleState || !titleState.isOverflowing) {
				return null;
			}

			return {
				'--nav-title-scroll-distance': `${titleState.distance}px`,
				'--nav-title-scroll-duration': `${titleState.duration}s`,
			};
		},
	},
}
</script>
<style scoped>
.nav-menu-link {
	display: flex;
	align-items: center;
	min-width: 0;
}

.nav-menu-title-wrap {
	display: block;
	flex: 1 1 auto;
	min-width: 0;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.nav-menu-parent-title {
	padding-right: 40px;
	box-sizing: border-box;
}

.nav-menu-title-inner {
	display: inline-block;
	min-width: 100%;
	will-change: transform;
}

.nav-menu-link:hover .nav-menu-title-wrap.is-overflowing,
.nav-menu-link:focus .nav-menu-title-wrap.is-overflowing {
	text-overflow: clip;
}

.nav-menu-link:hover .nav-menu-title-wrap.is-overflowing .nav-menu-title-inner,
.nav-menu-link:focus .nav-menu-title-wrap.is-overflowing .nav-menu-title-inner {
	animation: nav-menu-marquee var(--nav-title-scroll-duration, 2.2s) ease-in-out infinite alternate;
}

@keyframes nav-menu-marquee {
	from {
		transform: translateX(0);
	}

	to {
		transform: translateX(calc(-1 * var(--nav-title-scroll-distance, 0px)));
	}
}
</style>